function findFreeSpot(existing, widthPct, heightPct, stepX, stepY) {
  const clampX = (x) => Math.min(Math.max(x, 0), Math.max(0, 100 - widthPct));
  const clampY = (y) => Math.min(Math.max(y, 0), Math.max(0, 100 - heightPct));
  const overlaps = (x, y) => existing.some((t) => x < t.pos_left + t.width && x + widthPct > t.pos_left && y < t.pos_top + t.height && y + heightPct > t.pos_top);
  const cx = clampX(50 - widthPct / 2);
  const cy = clampY(50 - heightPct / 2);
  for (let ring = 0; ring <= 30; ring++) {
    for (let dx = -ring; dx <= ring; dx++) {
      for (let dy = -ring; dy <= ring; dy++) {
        if (Math.max(Math.abs(dx), Math.abs(dy)) !== ring) continue;
        const x = clampX(cx + dx * stepX);
        const y = clampY(cy + dy * stepY);
        if (!overlaps(x, y)) return { pos_left: x, pos_top: y };
      }
    }
  }
  return { pos_left: cx, pos_top: cy };
}
function nextFreeTableName(existingNames) {
  const names = new Set(existingNames.filter((n2) => !!n2));
  let n = 1;
  while (names.has(String(n))) n++;
  return String(n);
}
function nextFreeRowPrefix(existingPrefixes) {
  const used = new Set(existingPrefixes.filter((p) => !!p));
  for (let i = 0; i < 26; i++) {
    const candidate = String.fromCharCode(65 + i);
    if (!used.has(candidate)) return candidate;
  }
  return String.fromCharCode(65 + used.size);
}
function alignTables(op, tables) {
  if (tables.length < 2) return tables;
  if (op === "left") {
    const minX = Math.min(...tables.map((c) => c.pos_left));
    tables.forEach((c) => {
      c.pos_left = minX;
    });
  } else if (op === "top") {
    const minY = Math.min(...tables.map((c) => c.pos_top));
    tables.forEach((c) => {
      c.pos_top = minY;
    });
  } else if (op === "distribute-h") {
    tables.sort((a, b) => a.pos_left - b.pos_left);
    const first = tables[0].pos_left;
    const last = tables[tables.length - 1].pos_left;
    const gap = (last - first) / (tables.length - 1);
    tables.forEach((c, i) => {
      c.pos_left = first + gap * i;
    });
  } else if (op === "distribute-v") {
    tables.sort((a, b) => a.pos_top - b.pos_top);
    const first = tables[0].pos_top;
    const last = tables[tables.length - 1].pos_top;
    const gap = (last - first) / (tables.length - 1);
    tables.forEach((c, i) => {
      c.pos_top = first + gap * i;
    });
  }
  return tables;
}
export {
  alignTables,
  findFreeSpot,
  nextFreeRowPrefix,
  nextFreeTableName
};
//# sourceMappingURL=index50.js.map
